/**
 * SpotlightOverlay, multi-rect spotlight for guided tour.
 * Extracted from PlatformTour.js (Phase 3 refactor, 2026-05-03).
 */
import React from "react";

export const SpotlightOverlay = ({ rects, onClick }) => {
  if (!rects || rects.length === 0) {
    return (
      <div
        className="fixed inset-0 z-[9998] bg-black/70 transition-opacity duration-500"
        onClick={onClick}
      />
    );
  }

  const padding = 12;
  const paddedRects = rects.map((rect) => ({
    x: rect.x - padding,
    y: rect.y - padding,
    w: rect.width + padding * 2,
    h: rect.height + padding * 2,
  }));

  return (
    <svg
      className="fixed inset-0 z-[9998] w-full h-full transition-all duration-500"
      onClick={onClick}
    >
      <defs>
        <mask id="tour-spotlight-mask">
          <rect x="0" y="0" width="100%" height="100%" fill="white" />
          {paddedRects.map((r, i) => (
            <rect key={i} x={r.x} y={r.y} width={r.w} height={r.h} rx="16" ry="16" fill="black" />
          ))}
        </mask>
      </defs>
      <rect
        x="0" y="0"
        width="100%" height="100%"
        fill="rgba(0,0,0,0.72)"
        mask="url(#tour-spotlight-mask)"
      />
      {paddedRects.map((r, i) => (
        <rect
          key={i}
          x={r.x} y={r.y}
          width={r.w} height={r.h}
          rx="16" ry="16"
          fill="none"
          stroke="rgba(139,92,246,0.5)"
          strokeWidth="2"
          style={{ filter: "drop-shadow(0 0 12px rgba(139,92,246,0.4)) drop-shadow(0 0 30px rgba(139,92,246,0.2))" }}
        />
      ))}
    </svg>
  );
};
